import { render, staticRenderFns } from "./reciboCotizacion.vue?vue&type=template&id=3d61d2a6&scoped=true&"
import script from "./reciboCotizacion.vue?vue&type=script&lang=js&"
export * from "./reciboCotizacion.vue?vue&type=script&lang=js&"
import style0 from "./reciboCotizacion.vue?vue&type=style&index=0&id=3d61d2a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d61d2a6",
  null
  
)

export default component.exports